<template>
  <v-container fluid grid-list-md>
    <v-layout justify-space-between row wrap>
      <v-flex v-for="(item, i) in informations" :key="i" :class="item.class">
        <v-list three-line light class="py-0 elevation-2">
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title class="font-weight-bold">{{item.title}}</v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">{{item.subtitle}}</v-list-tile-sub-title>
              <v-list-tile-sub-title>{{item.value | currency}}</v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
    <!-- SUBMODULO 2.1 -->
    <v-layout justify-start row wrap>
      <v-flex xs12>
        <v-divider light></v-divider>
        <h3>Submódulo 2.1 - 13º (décimo terceiro) Salário, Férias e Adicional de Férias</h3>
      </v-flex>
      <v-flex xs12 sm4>
        <v-currency-field 
          box
          label="13º Salário (em %)" 
          v-bind="currency_config_percent"
          v-model="moduleTwo.thirteenFirstSalary"
          :hint="thirteenFirstSalaryValue | currency" 
          persistent-hint
          :readonly="budgetFinalized"
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-currency-field 
          box
          label="Adicional de Férias (em %)" 
          v-bind="currency_config_percent"
          v-model="moduleTwo.vacationAdditional"
          :hint="vacationAdditionalValue | currency" 
          persistent-hint
          :readonly="budgetFinalized"
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs12 sm4>
        <v-currency-field 
          box
          label="Total Submódulo 2.1 (em %)" 
          v-bind="currency_config_percent"
          :value="amountOfModuleTwoOnePercent"
          :hint="amountOfModuleTwoOneValue | currency" 
          persistent-hint
          disabled
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs12 class="pt-0">
        <v-textarea v-model="moduleTwo.notesOne" label="Notas" rows="5" box :readonly="budgetFinalized"></v-textarea>
      </v-flex>
    </v-layout>
    <!-- SUBMODULO 2.1 -->    
    <!-- SUBMODULO 2.2 -->
    <v-layout justify-start row wrap>
      <v-flex xs12>
        <v-divider light></v-divider>
        <h3>Submódulo 2.2 – Encargos Previdenciários (GPS), Fundo de Garantia por Tempo de Serviço (FGTS) e outras contribuições</h3>
      </v-flex>
      <v-flex xs6 sm4 md2>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="INSS" 
          v-bind="currency_config_percent"
          v-model="moduleTwo.inss"
          :hint="inssValue | currency" 
          persistent-hint
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs6 sm4 md2>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="FGTS" 
          v-bind="currency_config_percent"
          v-model="moduleTwo.fgts"
          :hint="fgtsValue | currency" 
          persistent-hint
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs6 sm4 md2>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="SESI/SESC" 
          v-bind="currency_config_percent"
          v-model="moduleTwo.sesiSesc"
          :hint="sesiSescValue | currency" 
          persistent-hint
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs6 sm4 md2>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="SENAI/SENAC" 
          v-bind="currency_config_percent"
          v-model="moduleTwo.senaiSenac"
          :hint="senaiSenacValue | currency" 
          persistent-hint
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs6 sm4 md2>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="INCRA" 
          v-bind="currency_config_percent"
          v-model="moduleTwo.incra"
          :hint="incraValue | currency" 
          persistent-hint
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs6 sm4 md2>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="SEBRAE" 
          v-bind="currency_config_percent"
          v-model="moduleTwo.sebrae"
          :hint="sebraeValue | currency" 
          persistent-hint
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs6 sm4 md2>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="Salário Educação" 
          v-bind="currency_config_percent"
          v-model="moduleTwo.educationSalary"
          :hint="educationSalaryValue | currency" 
          persistent-hint
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs6 sm4 md2>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="RAT" 
          v-bind="currency_config_percent"
          v-model="moduleTwo.rat"
          persistent-hint
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs6 sm4 md2>
        <v-currency-field 
          box :readonly="budgetFinalized"
          label="FAP" 
          v-bind="currency_config_normal"
          v-model="moduleTwo.fap"
          persistent-hint
        >
        </v-currency-field>
      </v-flex>
      
      <v-flex xs6 sm4 md2>
        <v-currency-field 
          box
          label="RAT x FAP" 
          v-bind="currency_config_percent"
          :value="ratFapPercent"
          :hint="ratFapValue | currency"
          persistent-hint
          disabled
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs12 sm8 md4>
        <v-currency-field 
          box 
          label="Total Submódulo 2.2" 
          v-bind="currency_config_percent"
          :value="amountOfModuleTwoTwoPercent"
          :hint="amountOfModuleTwoTwoValue | currency"
          persistent-hint
          disabled
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs12 class="pt-0">
        <v-textarea v-model="moduleTwo.notesTwo" label="Notas" rows="5" box :readonly="budgetFinalized"></v-textarea>
      </v-flex>
    </v-layout>
    <!-- SUBMODULO 2.2 -->
    <!-- SUBMODULO 2.3 -->
    <v-layout justify-start row wrap>
      <v-flex xs12>
        <v-divider light></v-divider>
        <h3>Submódulo 2.3 – Benefícios Mensais e Diários</h3>
      </v-flex>
      <v-flex xs12>
        <v-switch
          class="mt-2 " :readonly="budgetFinalized"
          @change="changeTransport"
          v-model="moduleTwo.transport.has"
          label="Auxílio Transporte"
        ></v-switch>
      </v-flex>
      <v-flex xs12 v-if="moduleTwo.transport.has" mt-0>
        <v-layout justify-start row wrap mt-0>
          <v-flex xs6 sm4 md2>
            <v-text-field :readonly="budgetFinalized" label="Bilhetes por dia" v-model="moduleTwo.transport.ticketByDay" type="number" min="0" box></v-text-field>
          </v-flex>
          <v-flex xs6 sm4 md2>
            <v-text-field :readonly="budgetFinalized" label="Nº dias mês" v-model="moduleTwo.transport.daysByMonth" type="number" min="0" box></v-text-field>
          </v-flex>
          <v-flex xs6 sm4 md2>
            <v-currency-field 
              box :readonly="budgetFinalized"
              label="Valor da Tarifa (em R$)" 
              v-bind="currency_config"
              v-model="moduleTwo.transport.tariffValue"
              persistent-hint
              :hint="tariffTransportHint"
            >
            </v-currency-field>
          </v-flex>
          <v-flex xs6 sm4 md2>
            <v-currency-field 
              box
              label="Custo Total" 
              v-bind="currency_config"
              :value="partialAmountOfTransport"
              disabled
            >
            </v-currency-field>
          </v-flex>
          <v-flex xs6 sm4 md2>
            <v-currency-field 
              box
              label="Custo Empregado" 
              v-bind="currency_config"
              :value="employeeCost"
              disabled
            >
            </v-currency-field>
          </v-flex>
          <v-flex xs6 sm4 md2>
            <v-currency-field 
              box
              label="Valor do Transporte" 
              v-bind="currency_config"
              :value="finalAmountOfTransport"
              disabled
            >
            </v-currency-field>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-switch
          class="mt-2 " :readonly="budgetFinalized"
          @change="changeFoodAid"
          v-model="moduleTwo.foodAid.has"
          label="Auxílio Refeição / Alimentação"
        ></v-switch>
      </v-flex>
      <v-flex xs12 v-if="moduleTwo.foodAid.has" mt-0>
        <v-layout justify-start row wrap mt-0>
          <v-flex xs6 sm3>
            <v-text-field :readonly="budgetFinalized" label="Refeição por Dia" v-model="moduleTwo.foodAid.mealByDay" type="number" min="0" box></v-text-field>
          </v-flex>
          <v-flex xs6 sm3>
            <v-text-field :readonly="budgetFinalized" label="Nº dias mês" v-model="moduleTwo.foodAid.daysByMonth" type="number" min="0" box></v-text-field>
          </v-flex>
          <v-flex xs6 sm3>
            <v-currency-field 
              box :readonly="budgetFinalized"
              label="Valor" 
              v-bind="currency_config"
              v-model="moduleTwo.foodAid.value"
            >
            </v-currency-field>
          </v-flex>
          <v-flex xs6 sm3>
            <v-currency-field 
              box
              label="Total Refeição / Alimentação" 
              v-bind="currency_config"
              :value="mealValue"
              disabled
            >
            </v-currency-field>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <!-- SUBMODULO 2.3 -->
    <!-- OUTROS BENEFÍCIOS -->
    <v-layout justify-start row wrap>
      <v-flex xs12 sm6>
        <h3>Outros Valores</h3>
        <h4 class="grey--text">Ex: Benefício Social Familiar, Benefício Assistencial, etc.</h4>
      </v-flex>
      <v-flex xs12 sm6>
        <v-btn v-if="!budgetFinalized" block color="primary" title="Adicionar benefício" @click.native.stop.prevent="addBenefit();">
          Adicionar Benefício
          <v-icon>add</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12>
        <v-layout v-show="moduleTwo.others.length > 0" v-for="(item, i) in moduleTwo.others" :key="i">
          <v-flex :class="budgetFinalized ? 'xs12' : 'xs11'">
            <v-layout justify-start row wrap>
              <v-flex xs12 sm6>
                <v-text-field :readonly="budgetFinalized" label="Descrição" v-model="item.description" box></v-text-field>
              </v-flex>
              <v-flex xs12 sm6>
                <v-currency-field 
                  box :readonly="budgetFinalized"
                  label="Valor" 
                  v-bind="currency_config"
                  v-model="item.value"
                >
                </v-currency-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs1 v-if="!budgetFinalized">
            <v-layout align-center justify-center row fill-height>
              <v-icon class="red--text font-weight-black" title="Remover benefício" @click.stop.prevent="removeBenefit(item);">delete_forever</v-icon>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12>
        <v-currency-field 
          box
          label="Total Submódulo 2.3" 
          v-bind="currency_config"
          v-model="amountOfModuleTwoThreeValue"
          disabled
        >
        </v-currency-field>
      </v-flex>
      <v-flex xs12 class="pt-0">
        <v-textarea v-model="moduleTwo.notesThree" label="Notas" rows="5" box :readonly="budgetFinalized"></v-textarea>
      </v-flex>
    </v-layout>
    <!-- OUTROS BENEFÍCIOS -->
  </v-container>
</template>

<script>
  import ModuleTwoService from '../../service/ModuleTwoService';
  import SheetDefaultData from '../../data/sheet/SheetDefaultData'
  import {mapState} from "vuex";
import Currency from '../../utils/Currency';

  export default {
    name: "TabModule2",

    data() {
      return {
        // CAMPOS //
        currency_config_percent: Currency.percent,
        currency_config_normal: Currency.normal,
        currency_config: Currency.real,
      }
    },
    methods: {
      addBenefit() {
        if(!this.moduleTwo.others)
          this.moduleTwo.others = new Array()

        this.moduleTwo.others.push({
          description: "",
          value: 0,
        });
      },
      changeFoodAid(){
        if(!this.moduleTwo.foodAid.has)
          this.moduleTwo.foodAid = {mealByDay: 0, daysByMonth: 0, value: 0}
      },
      changeTransport(){
        if(!this.moduleTwo.transport.has){
          this.moduleTwo.transport = {ticketByDay: 0, daysByMonth: 0, tariffValue: 0}
        }else if(this.cityOfService){
          this.moduleTwo.transport.tariffValue = this.cityOfService.busPassValue
        }
      },
      removeBenefit(item) {
        this.moduleTwo.others.splice(this.moduleTwo.others.indexOf(item), 1);
      },
      async setSheetModuleTwo() {
        let sheet = this.analyticalWorksheet
          if(sheet.moduleTwo != this.moduleTwo){
            sheet.moduleTwo = Object.assign({}, this.moduleTwo)
            await this.$store.commit("SET_ANALYTICAL_WORKSHEET", sheet);
          }
      } // setSheetModuleTwo()
    }, // methods: //

    computed: {
      amountOfModuleTwo() {
        let amount = parseFloat(this.amountOfModuleTwoOneValue) + 
            parseFloat(this.amountOfModuleTwoTwoValue) + 
            parseFloat(this.amountOfModuleTwoThreeValue);
        this.$store.commit("SET_AMOUNT_OF_MODULE_TWO", amount);

        return amount;
      },
      amountOfModuleTwoOnePercent() {
        return ModuleTwoService.getAmountOfModuleTwoOnePercents(this.moduleTwo);
      },
      amountOfModuleTwoOneValue() {
        let amount = ModuleTwoService.getAmountOfModuleTwoOne(this.amountOfModuleOne, this.moduleTwo)
        this.$store.commit("SET_AMOUNT_OF_MODULE_TWO_ONE", amount)
        return amount
      },
      amountOfModuleTwoTwoPercent() {
        let amount =  ModuleTwoService.getAmountOfModuleTwoTwoPercents(this.moduleTwo)
        this.$store.commit("SET_AMOUNT_OF_MODULE_TWO_TWO_PERCENT", amount)

        return amount
      },
      amountOfModuleTwoTwoValue() {
        return ModuleTwoService.getAmountOfModuleTwoTwo(this.moduleOneAndModuleTwoOne, this.moduleTwo)
      },
      amountOfModuleTwoThreeValue() {
        return ModuleTwoService.getAmountOfModuleTwoThree(this.basicSalaryCCT, this.moduleTwo)
      },
      basicSalaryCCT() {
        return this.analyticalWorksheet.header.professionalCategory.basicSalary
      },
      cityOfService(){
        if(this.analyticalWorksheet && this.analyticalWorksheet.header && this.analyticalWorksheet.header.deliveryAddress && this.analyticalWorksheet.header.deliveryAddress.cityOfService)
          return this.analyticalWorksheet.header.deliveryAddress.cityOfService
      },
      educationSalaryValue() {
        return this.moduleOneAndModuleTwoOne * this.moduleTwo.educationSalary / 100;
      },
      employeeCost() {
        return ModuleTwoService.getEmployeeCost(this.basicSalaryCCT)
      },
      fgtsValue() {
        return this.moduleOneAndModuleTwoOne * this.moduleTwo.fgts / 100;
      },
      finalAmountOfTransport() {
        return ModuleTwoService.getAmountOfTransport(this.basicSalaryCCT, this.moduleTwo.transport)
      },
      incraValue() {
        return this.moduleOneAndModuleTwoOne * this.moduleTwo.incra / 100;
      },
      informations(){
        return [
          {
            class: "xs12 sm6",
            title: "Valor da Remuneração",
            subtitle: "Total do Módulo 1",
            value: this.amountOfModuleOne
          },
          {
            class: "xs12 sm6",
            title: "Total do Módulo 2",
            subtitle: "Soma dos Submódulos (2.1, 2.2 e 2.3)",
            value: this.amountOfModuleTwo
          },
        ]
      },
      inssValue() {
        return this.moduleOneAndModuleTwoOne * this.moduleTwo.inss / 100;
      },
      mealValue() {
        return ModuleTwoService.getAmountOfFoodAid(this.moduleTwo.foodAid)
      },
      moduleOneAndModuleTwoOne() {
        return this.amountOfModuleTwoOneValue +  this.amountOfModuleOne;
      },
      moduleTwo(){
        if(this.analyticalWorksheet.moduleTwo)
          return this.analyticalWorksheet.moduleTwo
        
        return SheetDefaultData.getModuleTwo()
      },
      othersValue(){
        return ModuleTwoService.getOthers(this.moduleTwo.others)
      },
      partialAmountOfTransport() {
        return ModuleTwoService.getPartialAmountOfTransport(this.moduleTwo.transport)
      },
      ratFapPercent(){
        return this.moduleTwo.rat * this.moduleTwo.fap
      },
      ratFapValue() {
        return (this.moduleOneAndModuleTwoOne * this.ratFapPercent / 100);
      },
      sebraeValue() {
        return this.moduleOneAndModuleTwoOne * this.moduleTwo.sebrae / 100;
      },
      senaiSenacValue() {
        return this.moduleOneAndModuleTwoOne * this.moduleTwo.senaiSenac / 100;
      },
      sesiSescValue() {
        return this.moduleOneAndModuleTwoOne * this.moduleTwo.sesiSesc / 100;
      },
      tariffTransportHint(){
        if(!this.cityOfService)
          return ""  
        return `Cidade: ${this.cityOfService.name} - ${this.cityOfService.uf}`
      },
      thirteenFirstSalaryValue() {
        return  this.amountOfModuleOne * this.moduleTwo.thirteenFirstSalary / 100;
      },
      vacationAdditionalValue() {
        return  this.amountOfModuleOne * this.moduleTwo.vacationAdditional / 100;
      },
      ...mapState({amountOfModuleOne            : state => state.budget.amountOfModuleOne}),
      ...mapState({analyticalWorksheet          : state => state.budget.analyticalWorksheet}),
      ...mapState({budgetFinalized: state => state.budget.budgetFinalized})
    }, // computed: //
    watch: {
      moduleTwo: {
        handler: function(newValue, oldValue) {
          this.setSheetModuleTwo()
        },
        deep: true
      },
    }
  }; // export default //

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/budget/TabModule2.vue